import AssignmentIcon from '@mui/icons-material/Assignment';
import NotesIcon from '@mui/icons-material/Notes';
import FaceIcon from '@mui/icons-material/Face';
import GroupIcon from '@mui/icons-material/Group';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LayersIcon from '@mui/icons-material/Layers';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

/**
 * Event type configuration
 * Centralizes icon, color, and display logic for each event type
 */
export const EVENT_TYPES = {
  assignment: {
    icon: AssignmentIcon,
    color: 'warning.main',
    label: 'Assignment'
  },
  note: {
    icon: NotesIcon,
    color: 'info.main',
    label: 'Note'
  },
  match: {
    icon: FaceIcon,
    color: 'primary.main',
    label: 'Face Match'
  },
  soi_match: {
    icon: PersonSearchIcon,
    color: 'error.main',
    label: 'SOI Match'
  },
  multi_dataset_match: {
    icon: LayersIcon,
    color: 'secondary.main',
    label: 'Multi-Dataset Match'
  },
  group_match: {
    icon: GroupIcon,
    color: 'primary.main',
    label: 'Group Match'
  },
  promotion: {
    icon: PersonAddIcon,
    color: 'secondary.main',
    label: 'New Person'
  },
  detection: {
    icon: CameraAltIcon,
    color: 'grey.600',
    label: 'Detection'
  },
  soi_event: {
    icon: PersonSearchIcon,
    color: 'warning.main',
    label: 'Subject of Interest'
  }
};

/**
 * Get event type configuration
 * @param {string} eventType - The event type
 * @returns {Object} Configuration object with icon, color, and label
 */
export function getEventTypeConfig(eventType) {
  return EVENT_TYPES[eventType] || {
    icon: NotesIcon,
    color: 'grey.500',
    label: 'Unknown'
  };
}

/**
 * Format event date and time for display
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date and time
 */
export function formatEventDateTime(dateString) {
  if (!dateString) {
    console.warn('[formatEventDateTime] No dateString provided');
    return 'Invalid Date';
  }

  const eventDate = new Date(dateString);

  // Check if date is valid
  if (isNaN(eventDate.getTime())) {
    console.warn('[formatEventDateTime] Invalid dateString:', dateString);
    return 'Invalid Date';
  }

  const dateStr = eventDate.toLocaleDateString();
  const timeStr = eventDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return `${dateStr} ${timeStr}`;
}
